import type { Workspace, WorkspaceRole } from '../types/workspace'
import { isPersonalWorkspace } from '../utils/workspaceKind'

export interface ResolveActiveRoleParams {
  workspace: Pick<Workspace, 'isPersonal' | 'kind'> | null | undefined
  activeWorkspaceId: string | null | undefined
  rolesByWorkspaceId: Map<string, WorkspaceRole> | ReadonlyMap<string, WorkspaceRole> | null | undefined
}

/**
 * Resolves the active role for the current workspace.
 *
 * Behaviour:
 * - Personal workspace -> 'ADMIN'
 * - Otherwise (team workspace, etc.):
 *   - returns the role row from rolesByWorkspaceId if present
 *   - otherwise falls back to 'VIEWER'
 */
export const resolveActiveRole = ({
  workspace,
  activeWorkspaceId,
  rolesByWorkspaceId,
}: ResolveActiveRoleParams): WorkspaceRole => {
  if (isPersonalWorkspace(workspace)) {
    return 'ADMIN'
  }
  if (!activeWorkspaceId || !rolesByWorkspaceId) {
    return 'VIEWER'
  }
  return rolesByWorkspaceId.get(activeWorkspaceId) ?? 'VIEWER'
}
